import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UrlSerializer } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { TokenInterceptor } from './shared/helpers/token.interceptor';
import { ErrorInterceptor } from './shared/helpers/error.interceptor';
import { LogviewerIndexComponent } from './logviewer/index/logviewer-index.component';
import { LowerCaseUrlSerializer } from './shared/helpers/lower-case-url-serializer';
import { LogviewerLatencyComponent } from './logviewer/latency/logviewer-latency.component';
import { LogviewerViewdbComponent } from './logviewer/viewdb/logviewer-viewdb.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    LogviewerIndexComponent,
    LogviewerLatencyComponent,
    LogviewerViewdbComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule 
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
